import { render, staticRenderFns } from "./AddressInfo.vue?vue&type=template&id=8643e022&"
import script from "./AddressInfo.vue?vue&type=script&lang=js&"
export * from "./AddressInfo.vue?vue&type=script&lang=js&"
import style0 from "./AddressInfo.vue?vue&type=style&index=0&id=8643e022&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports